var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTherapy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1599 21.16C31.1599 25.12 27.9598 28.34 23.9998 28.34C20.0398 28.34 16.8398 25.12 16.8398 21.16C16.8398 17.2 20.0398 14 23.9998 14C27.9598 14 31.1599 17.2 31.1599 21.16Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.909 43.0595C33.3455 43.4542 31.4977 43.6364 29.3301 43.6364H18.6697C16.5021 43.6364 14.6543 43.4542 13.0908 43.0595C13.4817 39.1123 18.2256 36 23.9999 36C29.7743 36 34.5181 39.1123 34.909 43.0595Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2802 43.2395C34.5202 43.7595 32.4402 43.9995 30.0002 43.9995H18.0002C15.5602 43.9995 13.4802 43.7595 11.7202 43.2395C12.1602 38.0395 17.5002 33.9395 24.0002 33.9395C30.5002 33.9395 35.8402 38.0395 36.2802 43.2395Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4H18C8 4 4 8 4 18V30C4 37.56 6.28 41.7 11.72 43.24C12.16 38.04 17.5 33.9399 24 33.9399C30.5 33.9399 35.84 38.04 36.28 43.24C41.72 41.7 44 37.56 44 30V18C44 8 40 4 30 4ZM24 28.34C20.04 28.34 16.84 25.12 16.84 21.16C16.84 17.2 20.04 14 24 14C27.96 14 31.16 17.2 31.16 21.16C31.16 25.12 27.96 28.34 24 28.34Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1601 21.16C31.1601 25.12 27.9601 28.34 24.0001 28.34C20.0401 28.34 16.8401 25.12 16.8401 21.16C16.8401 17.2 20.0401 14 24.0001 14C27.9601 14 31.1601 17.2 31.1601 21.16Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapy);
export default __webpack_public_path__ + "static/media/Therapy.eb33ac76a7e43964bcafbe7f6cea3fd9.svg";
export { ForwardRef as ReactComponent };